import React, {Component} from 'react';
import './style.css'; //Is used. Do not remove.

export default class LoadingSpinner extends Component {
    render() {
        return (
            <div className="loader-8w376a8674a8w476a843a8sfas444"></div>
        );
    }
}
